/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const whatsAppAiAgentConfigInputDataSchema = z.object({
	goal: z.string().nullable().optional(),
	criteria: z.object({
		mustHave: z.array(z.string()).nullable().optional().default([]),
		niceToHave: z.array(z.string()).nullable().optional().default([]),
	}).nullable().optional(),
	languagePolicy: z.array(z.string()).nullable().optional(),
	handoffPolicy: z.array(z.string()).nullable().optional(),
	disallowedTopics: z.array(z.string()).nullable().optional(),
	maxTurns: z.number().nullable().optional(),
	maxDailyMessages: z.number().nullable().optional(),
	escoConfidenceThreshold: z.number().nullable().optional(),
	escoRequiresApproval: z.boolean().nullable().optional(),
})

export type WhatsAppAiAgentConfigInputDataSchema = z.infer<typeof whatsAppAiAgentConfigInputDataSchema>
